export const ROUTE_PATH = {
  BOOKING: "/booking/:hotelId",
  AUTH: "/auth",
  POLICY_AGREE: "/policy-agree",
  ROOM: "/room",
  PAYMENT: "/payment",
  CHECKOUT: "/check-out",
} as const;

export const RESERVATION_STATUS = {
  RR: "RR", // 체크인전 정상 예약
  CI: "CI", // 체크인
  CO: "CO", // 체크아웃
  N: "N", // no show
};

export const STORAGE_KEY = {
  TOKEN: "token",
  PARAMS: "params",
  CONFIG: "config",
  ROOM_NO: "room_no",
  SKIP_KAKAO: "skip_kakao",
};
